import { render, staticRenderFns } from "./StockRotation.vue?vue&type=template&id=0aaea4b0&"
import script from "./StockRotation.vue?vue&type=script&lang=js&"
export * from "./StockRotation.vue?vue&type=script&lang=js&"
import style0 from "./StockRotation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports